export default "__VITE_ASSET__B33PsJ$s__"